import Vue from 'vue'
import App from './App.vue'
import router from './router'
import env from '/config/env'       // 自定义配置
import tool from './assets/tool'    // 自定义工具
import 'font-awesome/css/font-awesome.min.css'
// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// Vue.use(ElementUI);
Vue.use(ElementUI, { size: "small" });
import 'mavon-editor/dist/css/index.css'
// 引入图片裁剪
import VueCropper from 'vue-cropper'

Vue.use(VueCropper)

Vue.config.productionTip = false

// 复制扩展
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// 全局自定义内容
Vue.prototype.env = env
Vue.prototype.Tool = tool
// 1.导入store对象
import store from './store/store'

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
